<a (click)="onItemClick(item)" *ngIf="!item.isSeparator && item.isCustomMenuItem" [pTooltip]="item.tooltip" [tooltipPosition]="menuPosition == 'right' ? 'left' : 'right'">
  <div class="item-container item-text-container">
    {{item.label}}
  </div>
</a>
<p-dialog *ngIf="isDialogVisible" (onAfterHide)="dialogHide()" appendTo="body" [responsive]="true"
          [(visible)]="isDialogVisible" showEffect="fade" header="Offener Posten import"
          [modal]="true" [width]="400" [height]="250">
  <p-fieldset legend="Offener Posten import">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          <p-fileUpload
            name="file[]"
            multiple="multiple"
            withCredentials="true"
            (onUpload)="onUpload($event)"
            url="{{baseUrl}}/api/phoenix/invoices/import/open-positions"
            accept=".csv"
            maxFileSize="100000000"
            chooseLabel="{{ 'COMMON.CHOOSE' | translate }}"
            cancelLabel="{{ 'COMMON.CANCEL' | translate }}"
            uploadLabel="{{ 'COMMON.UPLOAD' | translate }}"
          >
          </p-fileUpload></div>
      </div>
    </div>
    <div class="ui-grid-row">
      <p-progressBar *ngIf="isDataLoading" mode="indeterminate" [style]="{'height': '6px', 'margin-top': '5px'}"></p-progressBar>
    </div>
  </p-fieldset>
</p-dialog>
